import { Fragment, useEffect, useState } from "react";
import {
  Button,
  Card,
  Col,
  Container,
  FormControl,
  FormGroup,
  Modal,
  Row,
} from "react-bootstrap";
import {
  Files as FileComponent,
  Hash,
  PlusSquareFill,
  TrashFill,
} from "react-bootstrap-icons";
import Form from "react-bootstrap/Form";
import Table from "react-bootstrap/Table";
import { NumericFormat } from "react-number-format";
import { useNavigate } from "react-router-dom";
import { useSessionStorage } from "react-use";
import Swal from "sweetalert2";
import PackageSelect from "../../../components/Shipment/register/PackageSelect";
import {
  getRequestByAuth,
  handleEnter,
  postRequestByAuth,
} from "../../../function/helper";
import useSharedData from "../../../hooks/useSharedData";
import NewAddress from "../../components/addresses/NewAddress";
import FooterPostup from "../../public/footer/footer";
import Loading from "../../public/loading/loading";
import Menu from "../../public/menu/menu";
import ExInfoModal from "./ExInfoModal";
import Loader from "./Loader";
import ExternalAddressView from "./components/address/ExternalAddressView";
import NewExternalAddress from "./components/address/NewExternalAddress";
import PreviousAdress from "./components/address/PreviousAdress";
import DocumentUploadModal from "./components/document/DocumentUploadModal";
import "./newLetter.css";
import style from "./style.module.css";

function NewExternalAgent() {
  const [showPreviousAdressModal, setShowPreviousAdressModal] = useState(false);
  const [showDocumentUploadModal, setShowDocumentUploadModal] = useState(false);
  const [files, setFiles] = useState([]);
  const [showModalInfo, setShowModalInfo] = useState(false);
  const { isAgent } = useSharedData();

  const [rowsData, setRowsData] = useSessionStorage("rowsDataEx", [
    {
      partNumber: "",
      weight: "",
      length: "",
      width: "",
      height: "",
      mass: "",
      massUnround: "",
      content: "",
      brand: "",
      packaging: 0,
      cost: "",
    },
  ]);

  const [images, setImages] = useState([]);

  const [SAddress, setSAddress] = useSessionStorage("SAddressEx", {
    type: "",
    name: "",
    family: "",
    compony: "",
    irCode: "",
    shenase: "",
    mobile: "",
    tel: "",
    postCode: "",
    province: "",
    city: "",
    address: "",
    desc: "",
  });

  const [RAddress, setRAddress] = useSessionStorage("RAddressEx", {
    address: "",
    compony: "",
    family: "",
    id: 0,
    name: "",
    type: 0,
    phone: null,
    postCode: "",
    tel: "",
  });

  const [haghighi, sethaghighi] = useState(true);

  const finalServiceList = [];
  const [isLoading, setIsLoading] = useState(false);
  const [helpeer, sethelperr] = useState(true);
  const [hoghooghi, sethoghooghi] = useState(false);
  const [senderOrGetterRegAdd, setSenderOrGetterRegAdd] = useState(-1);
  const [modalAddressSender, setModalAddressSender] = useState(false);
  const [listAddressSender, setListAddressSender] = useState([]);

  const [totalNumber, setTotalNumber] = useSessionStorage("totalNumberEx", 0);

  const [totalCollectiveWeight, setTotalCollectiveWeight] = useSessionStorage(
    "totalCollectiveWeightEx",
    0
  );

  const [totalGrossWeight, setTotalGrossWeight] = useSessionStorage(
    "totalGrossWeightEx",
    0
  );

  const [totalWeightPayable, setTotalWeightPayable] = useSessionStorage(
    "totalWeightPayableEx",
    0
  );

  const [totalCost, setTotalCost] = useSessionStorage("totalCostEx", 20000000);
  const [errors, setErrors] = useSessionStorage("errorsEx", [{}]);
  const [modalSubmitFirst, setModalSubmitFirst] = useState(false);
  const [showModalWarning, setShowModalWarning] = useState(false);
  const [modalListService, setModalListService] = useState(false);
  const [selectedService, setSelectedService] = useState({});
  const [loading, setLoading] = useState(false);
  const [modalRules, setModalRules] = useState(false);
  const [packagingNeeded, setPackagingNeeded] = useState(false);
  const [printNeeded, setPrintNeeded] = useState(false);
  const [smsNeeded, setSmsNeeded] = useState(false);
  const [deliveryType, setDeliveryType] = useState(1);
  const [totalSpecialService, setTotalSpecialService] = useSessionStorage(
    "totalSpecialServiceEx",
    0
  );

  const [newAddress, setNewAddress] = useState(false);

  const validatevalue = vv => {
    if (vv <= 15_000_000) setTotalSpecialService(vv);
    else {
      Swal.fire({
        icon: "error",
        title: "اخطار",
        html: "<p style='font-size: 20px'>حداکثر مبلغ خدمات در محل 1 میلیون 500 هزار تومان</p>",
        confirmButtonText: '<i class="fa fa-thumbs-up"></i> فهمیدم',
        confirmButtonColor: "red",
        iconColor: "red",
      });
      setTotalSpecialService(0);
    }
  };

  const addTableRows = () => {
    const rowsInput = {
      partNumber: "",
      weight: "",
      length: "",
      width: "",
      height: "",
      mass: "",
      massUnround: "",
      content: "",
      brand: "",
      packaging: 0,
      cost: "",
    };
    rowsData.push(rowsInput);
    errors.push({});
    updateTotalInputs();
    generateBarcode();
  };

  const generateBarcode = () => {
    for (let i = 0; i < rowsData.length; i++) {
      const rowsInput = rowsData;
      rowsInput[i]["partNumber"] = lastPartNumber + i;
      setRowsData(rowsInput);
      sethelperr(!helpeer);
    }
  };

  const deleteTableRows = index => {
    rowsData.splice(index, 1);
    errors.splice(index, 1);
    updateTotalInputs();
    generateBarcode();
  };

  const duplicateRow = index => {
    const rowsInput1 = rowsData[index];

    const rowsInput = {
      partNumber: "",
      weight: rowsInput1["weight"],
      length: rowsInput1["length"],
      width: rowsInput1["width"],
      height: rowsInput1["height"],
      mass: rowsInput1["mass"],
      massUnround: rowsInput1["massUnround"],
      content: rowsInput1["content"],
      brand: rowsInput1["brand"],
      packaging: rowsInput1["packaging"],
      cost: rowsInput1["cost"],
    };
    rowsData.splice(index, 0, rowsInput);

    errors.splice(index, 0, {});

    updateTotalInputs();

    generateBarcode();
  };

  const handleChange = (index, evnt) => {
    const { name, value } = evnt.target;

    if (name === "weight") {
      if (value > 100) {
        return "ssad";
      }
    }
    if (name === "length" || name === "width" || name === "height") {
      if (value > 250) {
        return "";
      }
    }

    setRowsData(cur => {
      cur[index][name] = name === "packaging" ? parseInt(value) : value;

      const temp =
        (cur[index]["length"] * cur[index]["width"] * cur[index]["height"]) /
        6000;

      const mass = isNaN(temp) ? 0 : Math.round(temp * 100) / 100;
      const massUnround = isNaN(temp) ? 0 : temp;
      cur[index]["mass"] = mass;
      cur[index]["massUnround"] = massUnround;

      return [...cur];
    });

    if (errors[index]) {
      if (errors[index][name] != null || errors[index][name] != "") {
        errors[index][name] = null;
      }
    }

    updateTotalInputs();
    sethelperr(!helpeer);
  };

  const changeSenderType = event => {
    const value = event.target.value;
    if (value === "حقیقی") {
      sethaghighi(true);
      sethoghooghi(false);
    } else {
      sethaghighi(false);
      sethoghooghi(true);
    }
  };

  const lastPartNumber = 1000900;

  const getMyInfo = async () => {
    if (isAgent === false) {
      const response = await getRequestByAuth("/address/v1/default/address");

      if (response && response.status === 200) {
        const address = response.result;

        setSAddress({
          type: address.type,
          id: address.id,
          name: address.name,
          family: address.family,
          compony: address.compony,
          irCode: address.nationalCode,
          shenase: address.nationalCode,
          mobile: address.phone,
          tel: address.tel,
          postCode: address.postCode,
          province: address.province_name.faName,
          city: address.city_name.faName,
          address: address.address,
          chaparNumber: address.city_name.chaparNumber,
          desc: address.description,
        });
      }
    }

    generateBarcode();
  };

  useEffect(() => {
    setErrors(() => rowsData.map(() => ({})));
    getMyInfo();
    generateBarcode();
  }, []);

  const getAddressSender = async string => {
    setListAddressSender([]);
    if (string.length > 3) {
      setIsLoading(true);
      const addressSender = await getRequestByAuth(
        "/address/v1/search/0/" + string
      );
      setIsLoading(false);

      if (addressSender) {
        if (addressSender.status === 200) {
          setListAddressSender(addressSender.data);
        }
      }
    }
  };

  const selectAddS = item => {
    if (item.address.type == 1) {
      sethaghighi(false);
      sethoghooghi(true);
    } else {
      sethaghighi(true);
      sethoghooghi(false);
    }

    let description = "";
    if (item.address.description) {
      description = item.address.description;
    }

    setSAddress({
      type: item.address.type,
      id: item.address.id,
      name: item.address.name,
      family: item.address.family,
      compony: item.address.compony,
      irCode: item.address.nationalCode,
      shenase: item.address.nationalCode,
      mobile: item.address.phone,
      tel: item.address.tel,
      postCode: item.address.postCode,
      province: item.address.province_name.faName,
      city: item.address.city_name.faName,
      address: item.address.address,
      chaparNumber: item.address.city_name.chaparNumber,
      desc: description,
    });
    setModalAddressSender(false);
  };

  const regAddress = string => {
    if (string === "sender") {
      setSenderOrGetterRegAdd(0);
    }

    setModalAddressSender(false);
  };

  const updateTotalInputs = () => {
    setTotalNumber(rowsData.length);

    let totalWeight = 0;
    for (let i = 0; i < rowsData.length; i++) {
      if (rowsData[i]["weight"]) {
        totalWeight =
          parseFloat(totalWeight) + parseFloat(rowsData[i]["weight"]);
      }
    }
    setTotalCollectiveWeight(totalWeight);

    let totalMass = 0;
    let temp2 = 0;
    for (let j = 0; j < rowsData.length; j++) {
      if (rowsData[j]["mass"]) {
        temp2 = parseFloat(temp2) + parseFloat(rowsData[j]["mass"]);
      }
    }
    totalMass = Math.round(temp2 * 100) / 100;
    setTotalGrossWeight(totalMass);

    let totalPayable = 0;

    if (totalMass >= totalWeight) {
      totalPayable = Math.ceil(totalMass * 2) / 2;
    } else if (totalWeight > totalMass) {
      totalPayable = Math.ceil(totalWeight * 2) / 2;
    }
    setTotalWeightPayable(totalPayable);

    let sumCost = 0;
    for (let l = 0; l < rowsData.length; l++) {
      if (rowsData[l]["cost"]) {
        sumCost = parseFloat(sumCost) + parseFloat(rowsData[l]["cost"]);
      }
    }
    setTotalCost(sumCost);
  };

  const findFormErrors = indexx => {
    const newErrors = {};

    const { weight, length, width, height, content } = rowsData[indexx];
    if (!weight) newErrors.weight = "وزن الزامی است";
    if (!length) {
      newErrors.length = "طول الزامی است";
    }
    if (!width) {
      newErrors.width = "عرض الزامی است";
    }
    if (!height) {
      newErrors.height = "ارتفاع الزامی است";
    }
    if (!content) {
      newErrors.content = "مشخص کردن محتویات مرسوله الزامی است";
    }

    if (!images[indexx]) {
      newErrors.images = "سه تصویر الزامی است";
    } else if (!images[indexx][0] || !images[indexx][1] || !images[indexx][2]) {
      newErrors.images = "سه تصویر الزامی است";
    }

    return newErrors;
  };

  const handleSubmitLetter = e => {
    e.preventDefault();
    let totalErrrors = [];
    for (let h = 0; h < rowsData.length; h++) {
      const newErrors = findFormErrors(h);

      totalErrrors.push(newErrors);
    }

    let x = true;

    for (let d = 0; d < totalErrrors.length; d++) {
      if (totalErrrors[d] != null) {
        if (Object.keys(totalErrrors[d]).length > 0) {
          x = false;
          setErrors(totalErrrors);
        }
      }
    }

    if (x === false) {
      return;
    }

    if (!SAddress.address) {
      Swal.fire({
        icon: "error",
        text: "آدرس فرستنده مشخص نشده است",
        showConfirmButton: true,
        confirmButtonText: "متوجه شدم",
        confirmButtonColor: "gray",
      });
      return;
    }

    if (!RAddress.address) {
      Swal.fire({
        icon: "error",
        text: "آدرس گیرنده مشخص نشده است",
        showConfirmButton: true,
        confirmButtonText: "متوجه شدم",
        confirmButtonColor: "gray",
      });
      return;
    }

    setModalRules(true);
  };

  const chooseServiceType = () => {
    if (Object.keys(selectedService).length != 0) {
      setModalListService(false);
      setModalSubmitFirst(true);
    } else {
      Swal.fire({
        icon: "error",
        text: "نوع سرویس را انتخاب نکرده اید",
        showConfirmButton: true,
        confirmButtonText: "متوجه شدم",
        confirmButtonColor: "gray",
      });
    }
  };

  const navigate = useNavigate();

  const sendRequest = async () => {
    setLoading(true);

    const formData = new FormData();

    formData.append("addressId", SAddress.id);
    formData.append("getterAddressId", RAddress.id);
    formData.append("needPackaging", packagingNeeded);
    formData.append("printFactor", printNeeded);
    formData.append("hasNotifRequest", smsNeeded);

    rowsData.forEach((item, idx) =>
      Object.keys(item).map(key =>
        formData.append(`data[${idx}][${key}]`, item[key])
      )
    );

    files.forEach(item => formData.append("documents[]", item));

    formData.append("totalCollectiveWeight", totalCollectiveWeight);
    formData.append("totalGrossWeight", totalGrossWeight);
    formData.append("totalWeightPayable", totalWeightPayable);
    formData.append("totalCost", totalCost);
    formData.append("delivery_type", deliveryType);

    images.forEach((image, idx) => {
      image.forEach(item => {
        formData.append(`images[${idx}][]`, item.file);
      });
    });

    formData.append("price", 0);
    formData.append("isAgent", isAgent);

    const response = await postRequestByAuth(
      "/external-post/v1/add",
      formData,
      true
    );

    if (response.status === 201) {
      navigate(`/pay?id=${response.data.numberParcel}`);
    } else {
      setLoading(false);
      Swal.fire({
        icon: "error",
        text: response.data.line
          ? "عملیات با خطا مواجه شد"
          : response.data.message,
        showConfirmButton: true,
        confirmButtonText: "متوجه شدم",
      });
    }
  };

  const onSelectFile = (e, i, number) => {
    if (!e.target.files[0]) return;
    const tempImages = images;
    if (!tempImages[i]) {
      tempImages.push([]);
    }

    const image = tempImages[i].findIndex(item => item.id === number);

    if (image !== -1) {
      tempImages[i][image] = {
        id: number,
        blob: URL.createObjectURL(e.target.files[0]),
        file: e.target.files[0],
      };
    } else
      tempImages[i].push({
        id: number,
        blob: URL.createObjectURL(e.target.files[0]),
        file: e.target.files[0],
      });

    setImages(() => [...tempImages]);

    sethelperr(!helpeer);
  };

  useEffect(() => {
    document.addEventListener("keydown", function (event) {
      if (event.keyCode === 13 && event.target.nodeName === "INPUT") {
        const form = event.target.form;
        if (form?.elements === undefined) return;

        const index = Array.prototype.indexOf.call(form, event.target);
        form.elements[index + 1].focus();
        event.preventDefault();
      }
    });
  }, []);

  if (loading) {
    return <Loading />;
  } else {
    return (
      <>
        <Menu />

        <div className="new-letter-style">
          <Container fluid className="fluid">
            <div className="home-title-pagee my-5">
              <p className="colloborate-title">فرم ثبت سفارش پست خارجی</p>
            </div>

            <div className="loginFormCol">
              <Card className="loginForm">
                <Row className="sender">
                  <p className="title-style">فرستنده</p>
                  <div className="mb-2">
                    <button
                      type="button"
                      className="btn-orange-header-button"
                      onClick={() => regAddress("sender")}
                    >
                      ثبت آدرس جدید
                    </button>
                    <button
                      type="button"
                      onClick={() => {
                        setModalAddressSender(true);
                        setListAddressSender([]);
                      }}
                      className="header-button blueShadow blueBackground me-3"
                      style={{ width: "200px" }}
                    >
                      انتخاب آدرس قبلی فرستنده
                    </button>
                  </div>

                  <hr className="titre-line mb-2" />

                  <div className={"d-flex flex-wrap " + style.exBox}>
                    <Col>
                      <Form.Label>
                        نوع: <span className="text-danger">*</span>
                      </Form.Label>
                      <Form.Select
                        className="select"
                        name=""
                        value={SAddress.type ?? "0"}
                        disabled
                        onChange={evnt => changeSenderType(evnt)}
                      >
                        <option value="0" name="">
                          حقیقی
                        </option>
                        <option value="1" name="">
                          حقوقی
                        </option>
                      </Form.Select>
                    </Col>
                    {haghighi ? (
                      <Col>
                        <Form.Label>
                          نام:<span className="text-danger">*</span>
                        </Form.Label>
                        <Form.Control
                          type="text"
                          name=""
                          value={SAddress.name ?? ""}
                          disabled
                        />
                      </Col>
                    ) : null}

                    {haghighi ? (
                      <Col>
                        <Form.Label>
                          نام خانوادگی:<span className="text-danger">*</span>
                        </Form.Label>
                        <Form.Control
                          type="text"
                          name=""
                          value={SAddress.family ?? ""}
                          disabled
                        />
                      </Col>
                    ) : null}

                    {hoghooghi ? (
                      <Col>
                        <Form.Label>
                          نام شرکت:<span className="text-danger">*</span>
                        </Form.Label>
                        <Form.Control
                          type="text"
                          name=""
                          value={SAddress.compony ?? ""}
                          disabled
                        />
                      </Col>
                    ) : null}

                    {haghighi ? (
                      <Col>
                        <Form.Label>
                          کد ملی: <span className="text-danger">*</span>
                        </Form.Label>
                        <Form.Control
                          type="text"
                          name=""
                          value={SAddress.irCode ?? ""}
                          disabled
                        />
                      </Col>
                    ) : null}

                    {hoghooghi ? (
                      <Col>
                        <Form.Label>
                          شناسه ملی: <span className="text-danger">*</span>
                        </Form.Label>
                        <Form.Control type="text" name="" />
                      </Col>
                    ) : null}

                    <Col>
                      <Form.Label>
                        موبایل:<span className="text-danger">*</span>
                      </Form.Label>
                      <Form.Control
                        type="text"
                        name=""
                        value={SAddress.mobile ?? ""}
                        disabled
                      />
                    </Col>
                    <Col>
                      <Form.Label> تلفن:</Form.Label>
                      <Form.Control
                        type="text"
                        name=""
                        value={SAddress.tel ?? ""}
                        disabled
                      />
                    </Col>

                    <Col>
                      <Form.Label> کد پستی: </Form.Label>
                      <Form.Control
                        type="text"
                        name=""
                        value={SAddress.postCode ?? ""}
                        disabled
                      />
                    </Col>

                    <Col>
                      <Form.Label>
                        استان:<span className="text-danger">*</span>
                      </Form.Label>
                      <Form.Control
                        type="text"
                        value={SAddress.province ?? ""}
                        disabled
                      />
                    </Col>

                    <Col>
                      <Form.Label>
                        شهر:<span className="text-danger">*</span>
                      </Form.Label>
                      <Form.Control
                        type="text"
                        value={SAddress.city ?? ""}
                        disabled
                      />
                    </Col>

                    <Col className="w-100">
                      <Form.Label>
                        آدرس:<span className="text-danger">*</span>
                      </Form.Label>
                      <Form.Control
                        as="textarea"
                        name=""
                        value={SAddress.address ?? ""}
                        disabled
                      />
                    </Col>

                    <Col className="w-100">
                      <Form.Label> توضیحات:</Form.Label>
                      <Form.Control
                        as="textarea"
                        name=""
                        value={SAddress.desc ?? ""}
                        disabled
                      />
                    </Col>
                  </div>
                </Row>
                <p className="title-style mt-4">گیرنده</p>
                <div>
                  <button
                    className="btn-orange-header-button"
                    onClick={() => setNewAddress(true)}
                  >
                    ثبت آدرس گیرنده جدید
                  </button>

                  <button
                    className="header-button blueShadow blueBackground me-3"
                    style={{ height: 36, width: 200 }}
                    onClick={() => setShowPreviousAdressModal(true)}
                  >
                    انتخاب آدرس قبلی گیرنده
                  </button>
                </div>

                <hr className="titre-line mb-4" />
                <ExternalAddressView information={RAddress} />

                <hr />
                <Row>
                  <Col>
                    <p className="h5 text-end">
                      محدودیت های وزنی پستی بشرح زیر می باشد:
                    </p>
                    <ul>
                      <li>حداکثر وزن برای پست پیشتاز و پست خارجی 30 کیلوگرم</li>
                      <li>
                        حداکثر وزن بسته پستی در شرکت های خصوصی 100 کیلوگرم
                      </li>
                      <li>
                        حداکثر وزن بسته پستی برای پیک درون شهری 20 کیلوگرم
                      </li>
                    </ul>
                  </Col>
                  <Col>
                    <p className="h5 text-end">
                      بیمه مرسولات شما توسط آواکس بصورت زیر میباشد:
                    </p>
                    <ul>
                      <li>انتخاب بیمه الزامی است.</li>
                    </ul>
                  </Col>
                </Row>
                <hr />
                <Form
                  className="needs-validation"
                  onSubmit={handleSubmitLetter.bind()}
                  onKeyDown={event => {
                    if (event.keyCode == 13) {
                      event.keyCode = 9;
                      return event.keyCode;
                    }
                  }}
                >
                  <Row>
                    <p className="title-style">مشخصات مرسوله</p>
                    <Table
                      striped
                      bordered
                      hover
                      responsive
                      className={"tbl-styl " + style.tableDetail}
                    >
                      <thead>
                        <tr className="table-style">
                          <th>
                            <button
                              type="button"
                              className="p-0 m-0"
                              onClick={generateBarcode}
                            >
                              <Hash color="blue" />
                              شماره پارت
                            </button>
                          </th>
                          <th>وزن (کیلوگرم)</th>
                          <th>طول * عرض * ارتفاع (cm)</th>
                          <th>وزن حجمی</th>
                          <th>محتویات و تعداد آن</th>
                          <th>برند(سازنده) و مدل</th>

                          <th>نوع بسته بندی</th>
                          <th>ارزش کالا/بیمه(ريال)</th>
                        </tr>
                      </thead>
                      <tbody>
                        {rowsData.map((data, index) => {
                          const {
                            partNumber,
                            weight,
                            length,
                            width,
                            height,
                            mass,
                            content,
                            brand,
                            packaging,
                            cost,
                          } = data;

                          return (
                            <Fragment key={index}>
                              <tr className="table-body-style">
                                <td>
                                  <Form.Control
                                    disabled
                                    type="text"
                                    name="partNumber"
                                    value={partNumber}
                                    onChange={evnt => handleChange(index, evnt)}
                                  />
                                </td>
                                <td>
                                  <Form.Control
                                    type="number"
                                    name="weight"
                                    value={weight}
                                    onChange={evnt => handleChange(index, evnt)}
                                    isInvalid={!!errors[index].weight}
                                  />
                                  <Form.Control.Feedback type="invalid">
                                    {errors[index].weight}
                                  </Form.Control.Feedback>
                                </td>
                                <td>
                                  <div className={style.dimentions}>
                                    <Col>
                                      <Form.Control
                                        placeholder=""
                                        type="number"
                                        name="length"
                                        value={length}
                                        onChange={evnt =>
                                          handleChange(index, evnt)
                                        }
                                        isInvalid={!!errors[index].length}
                                      />
                                      <Form.Control.Feedback type="invalid">
                                        {errors[index].length}
                                      </Form.Control.Feedback>
                                    </Col>
                                    <Col>
                                      <Form.Control
                                        placeholder=""
                                        type="number"
                                        name="width"
                                        value={width}
                                        onChange={evnt =>
                                          handleChange(index, evnt)
                                        }
                                        isInvalid={!!errors[index].width}
                                      />
                                      <Form.Control.Feedback type="invalid">
                                        {errors[index].width}
                                      </Form.Control.Feedback>
                                    </Col>
                                    <Col>
                                      <Form.Control
                                        placeholder=""
                                        type="number"
                                        name="height"
                                        value={height}
                                        onChange={evnt =>
                                          handleChange(index, evnt)
                                        }
                                        isInvalid={!!errors[index].height}
                                      />
                                      <Form.Control.Feedback type="invalid">
                                        {errors[index].height}
                                      </Form.Control.Feedback>
                                    </Col>
                                  </div>
                                </td>
                                <td>
                                  <Form.Control
                                    type="number"
                                    name="mass"
                                    value={mass}
                                    disabled
                                    placeholder=""
                                    onKeyDown={e => handleEnter(e)}
                                  />
                                </td>
                                <td>
                                  <Form.Control
                                    type="text"
                                    name="content"
                                    value={content}
                                    onChange={evnt => handleChange(index, evnt)}
                                    isInvalid={!!errors[index].content}
                                    placeholder="مثلا:4 عدد گوشی موبایل"
                                  />
                                  <Form.Control.Feedback type="invalid">
                                    {errors[index].content}
                                  </Form.Control.Feedback>
                                </td>
                                <td>
                                  <Form.Control
                                    type="text"
                                    name="brand"
                                    value={brand}
                                    onChange={evnt => handleChange(index, evnt)}
                                    isInvalid={!!errors[index].brand}
                                  />
                                  <Form.Control.Feedback type="invalid">
                                    {errors[index].brand}
                                  </Form.Control.Feedback>
                                </td>

                                <td>
                                  <PackageSelect
                                    name="packaging"
                                    value={packaging}
                                    style={{ height: "38px" }}
                                    onChange={value =>
                                      handleChange(index, {
                                        target: { value, name: "packaging" },
                                      })
                                    }
                                  />
                                </td>
                                <td>
                                  <NumericFormat
                                    className="form-control"
                                    name="cost"
                                    suffix=" ریال"
                                    value={cost}
                                    thousandSeparator=","
                                    onValueChange={({ value }) => {
                                      handleChange(index, {
                                        target: { name: "cost", value },
                                      });
                                    }}
                                  />

                                  <Form.Control.Feedback type="invalid">
                                    {errors[index].cost}
                                  </Form.Control.Feedback>
                                </td>
                              </tr>

                              <tr>
                                <td>آپلود عکس(3 عدد)</td>

                                <td colSpan={6}>
                                  <Row>
                                    <Col>
                                      <Form.Control
                                        type="file"
                                        onChange={e =>
                                          onSelectFile(e, index, 1)
                                        }
                                        size="sm"
                                        accept="image/*"
                                        className="mb-2"
                                        isInvalid={!!errors[index].images}
                                      />
                                      <Form.Control.Feedback type="invalid">
                                        {errors[index]?.images}
                                      </Form.Control.Feedback>
                                    </Col>

                                    <Col>
                                      <Form.Control
                                        type="file"
                                        onChange={e =>
                                          onSelectFile(e, index, 2)
                                        }
                                        size="sm"
                                        accept="image/*"
                                        className="mb-2"
                                        isInvalid={!!errors[index].images}
                                      />
                                    </Col>
                                    <Col>
                                      <Form.Control
                                        type="file"
                                        onChange={e =>
                                          onSelectFile(e, index, 3)
                                        }
                                        size="sm"
                                        accept="image/*"
                                        className="mb-2"
                                        isInvalid={!!errors[index].images}
                                      />
                                    </Col>
                                  </Row>

                                  <Row>
                                    {images[index]
                                      ? images[index].map((item, itemIndex) => (
                                          <img
                                            key={itemIndex}
                                            src={item.blob}
                                            style={{
                                              width: 200,
                                              height: 100,
                                              objectFit: "cover",
                                              objectPosition: "center",
                                            }}
                                          />
                                        ))
                                      : ""}
                                  </Row>
                                </td>
                                <td>
                                  <Row className="d-flex align-items-center justify-content-center">
                                    <button
                                      type="button"
                                      onClick={() => {
                                        deleteTableRows(index);
                                      }}
                                      className="d-inline-block p-1 mx-0 buton-form btn btn-link"
                                    >
                                      <TrashFill
                                        color="red"
                                        size={20}
                                        className=""
                                        title="حذف سطر"
                                      />
                                    </button>
                                    <button
                                      type="button"
                                      onClick={() => {
                                        duplicateRow(index);
                                      }}
                                      className="d-inline-block p-1 mx-0 buton-form btn btn-link"
                                    >
                                      <FileComponent
                                        color="blue"
                                        size={20}
                                        title="کپی سطر"
                                      />
                                    </button>
                                    <button
                                      type="button"
                                      onClick={addTableRows}
                                      className="d-inline-block p-1 mx-0 buton-form btn btn-link"
                                    >
                                      <PlusSquareFill
                                        size={22}
                                        color="green"
                                        title="افزودن سطر جدید"
                                      />
                                    </button>
                                  </Row>
                                </td>
                              </tr>
                            </Fragment>
                          );
                        })}
                      </tbody>
                    </Table>

                    <Row className="mt-4">
                      <Col>
                        <Form.Control
                          name="totalNumber"
                          value={totalNumber}
                          disabled
                        />
                        <p>مجموع تعداد پارت ها</p>
                      </Col>
                      <Col>
                        <Form.Control
                          name="totalCollectiveWeight"
                          value={totalCollectiveWeight}
                          disabled
                        />
                        <p>مجموع وزن ناخالص</p>
                      </Col>
                      <Col>
                        <Form.Control
                          name="totalGrossWeight"
                          value={totalGrossWeight}
                          disabled
                        />
                        <p>مجموع وزن حجمی</p>
                      </Col>
                      <Col>
                        <Form.Control
                          name="totalWeightPayable"
                          value={totalWeightPayable}
                          disabled
                        />
                        <p>مجموع وزن قابل پرداخت</p>
                      </Col>
                      <Col>
                        <Form.Control
                          name="totalCost"
                          value={totalCost.toLocaleString()}
                          disabled
                        />
                        <p>مجموع ارزش کالا</p>
                      </Col>
                      <Col className="rtl">
                        <NumericFormat
                          name="totalSpecialService"
                          className="form-control"
                          value={totalSpecialService}
                          thousandSeparator=","
                          min={0}
                          max={5000000}
                          onValueChange={e => {
                            const { value } = e;
                            validatevalue(value);
                          }}
                        />
                        <p>مجموع خدمات در محل(ريال)</p>
                      </Col>
                    </Row>

                    <hr />
                  </Row>
                  <div className="text-center">
                    <Button type="submit" className="btn-success-style">
                      تائید
                    </Button>
                  </div>
                </Form>
              </Card>
            </div>

            <Modal show={modalAddressSender} direction="rtl">
              <Modal.Header className="d-flex align-item-center justify-content-center">
                <Modal.Title>
                  جستجو از آدرس های ثبت شده قبلی فرستنده
                </Modal.Title>
              </Modal.Header>
              <Modal.Body
                className="d-flex align-item-center justify-content-center text-right "
                style={{ textAlign: "right", direction: "rtl" }}
              >
                <div className="w-100">
                  <FormGroup>
                    <Row className="mt-2">
                      <Col lg={12} md={12} sm={12}>
                        <Form.Label>
                          جستجوی آدرس (حداقل چهار کاراکتر الزامی است)
                        </Form.Label>
                        <FormControl
                          type="text"
                          onChange={e => getAddressSender(e.target.value)}
                        ></FormControl>
                        {isLoading && (
                          <div className={style.container}>
                            <Loader />
                          </div>
                        )}
                        {listAddressSender.map((item, idx) => (
                          <button
                            className="btn btn-light m-1"
                            key={idx}
                            onClick={() => selectAddS(item)}
                          >
                            {item.address.country_name.faName} -
                            {item.address.province_name.faName} -
                            {item.address.city_name.faName} -{" "}
                            {item.address.totalAddress} -{item.address.compony}{" "}
                            - {item.address.phone}
                          </button>
                        ))}
                      </Col>
                    </Row>
                  </FormGroup>
                </div>
              </Modal.Body>
              <Modal.Footer className="d-flex align-item-center justify-content-center">
                <Button
                  className="btn-cancel-style"
                  onClick={() => setModalAddressSender(false)}
                >
                  بستن
                </Button>
                <Button
                  className="btn-success-style"
                  onClick={() => regAddress("sender")}
                >
                  ثبت آدرس جدید
                </Button>
              </Modal.Footer>
            </Modal>

            <Modal show={modalRules} direction="rtl" size="xl">
              <Modal.Body className="d-flex align-item-center justify-content-center text-right">
                <div className="w-100">
                  <Row>
                    <Col>
                      <button
                        className="btn-success-style d-flex align-items-center justify-content-center w-100"
                        type="button"
                        onClick={() => {
                          setModalRules(false);
                          setModalSubmitFirst(true);
                        }}
                      >
                        قوانین را خواندم و پذیرفتم
                      </button>
                    </Col>
                    <Col>
                      <button
                        className="btn-cancel-style d-flex align-items-center justify-content-center w-100"
                        type="button"
                        onClick={() => {
                          setModalRules(false);
                        }}
                      >
                        بستن
                      </button>
                    </Col>
                  </Row>
                  <p
                    style={{
                      textAlign: "right",
                      direction: "rtl",
                      fontSize: "16px",
                    }}
                  >
                    قوانین اجرایی سامانه آواکس :<br />
                    <br />
                    1-ارسال کننده (کاربر)بایستی در هنگام ثبت سفارش وزن و محتوای
                    بسته را بدرستی به دقت و صداقت اعلام نماید چنانچه وزن اعلام
                    شده مغایر با وزن واقعی باشد ، سفارش کنسل خواهد شد و مسئولیت
                    تاخیر در ارسال، هزینه سفارش مجدد و یا هرگونه خسارت ناشی از
                    این امر به عهده ارسال کننده خواهد بود
                    <br />
                    2- کاربر میبایست آدرس گیرنده را درهنگام ثبت به درستی درج
                    نماید تا موجب برگشتی سفارش و یا هزینه های مجدد نگردد
                    <br />
                    کاربر بایستی آدرس فرستنده اعم از استان، شهر و منطقه را صحیح
                    انتخاب نماید و چنانچه این امر به درستی صورت نگیرد مسئولیت
                    ناشی از تاخیر در جمع آوری و یا کنسلی سفارش به عهده کاربر
                    خواهد بود
                    <br />
                    کاربر بایستی از شنبه تا پنجشنبه، جهت تحویل مرسوله به جمع آور
                    تا ساعت 19 در محل اظهار شده ثبت سفارش (آدرس فرستنده) حضور
                    داشته باشد و در صورت عدم حضور، این امر به منزله لغو سفارش
                    است و هیچ مبلغی از بابت سفارش لغو شده مسترد نخواهد شد و
                    همچنین هیچ گونه ادعایی در این خصوص نخواهد داشت. همچنین در
                    شرایط آب و هوایی بارانی یا برفی و یا مناطق گرمسیر (درجه
                    حرارت بالای ۴۵ درجه) و مناطق سرد سیر (درجه حرارت زیر صفر
                    درجه) این امکان وجود دارد که فرایند جمع آوری با تاخیر انجام
                    پذیرد.
                    <br />
                    کلیه سفارشات ثبت شده در روزجمعه و ایام تعطیل در اولین روز
                    کاری بعد از ثبت سفارش جمع آوری خواهد شد وکاربر در این خصوص
                    هیچ اعتراضی نخواهد داشت، <br />
                    کاربر میبایست هر گونه شکایت در خصوص خسارت وارده به هر مرسوله
                    ای را صرفا ظرف 24ساعت پس از سفارش از و عدم پذیرش آن مرسوله
                    اعلام دارد و در غیر این صورت هیچ گونه اعتراضی نخواهد داشت
                    ضمنا تعهد بیمه مرسوله تا لحظه تحویل آن به گیرنده اعتبار
                    خواهد داشت.
                    <br />
                    کاربر بایستی که کالای فاسد شدنی ، ممنوعات پستی و قاچاق، وزن
                    بیش از 30کیلو، مایعات و ابعاد بیش از 1 متر در مرسوله پستی
                    قرار ندهد و مندرجات بند ممنوعات پستی رارعایت نماید <br />
                    و همچنین کالای شکستنی ارسال ننماید مگر آنکه کلیه ضوابط بسته
                    بندی را رعایت نموده باشد، که در صورت عدم رعایت ضابطه فوق و
                    بروز خسارت، هیچ اعتراضی نخواهد داشت و مسئولیت محتوای کلیه
                    کالاهای مندرج در بسته به عهدهشخص کاربر می باشد، همچنین شرکت
                    هیچ گونه مسئولیتی در قبال اطلاع رسانی بسته بندی مرسوله ندارد
                    و در صورت ارسال مرسوله با هرنوع بسته بندی تبعات آن به عهده
                    فرستنده می باشد.
                    <br />
                    کاربر بایستی سفارش خود را که حاوی کد رهگیری می باشد را پرینت
                    و بر روی بسته الصاق نماید وحتما آنرا امضا کند و سپس نسخه
                    دیگر را به امضای جمع آور برساند و به عنوان رسید نزد خود نگه
                    دارد. ضمنا کلیه قوانین پستی را در خصوص محتوای بسته پستی
                    رعایت نماید و اگر خلاف این امر را انجام دهد کلیه مسئولیت های
                    ناشی از خسارت و غیره به عهده کاربر می باشد و اگر چنانچه به
                    پرینتر دسترسی نداشته باشد، آدرس فرستنده، گیرنده و شماره
                    سفارش را بر روی بسته بندی مرسوله با ماژیک درج بنماید
                    <br />
                    کاربر نمیتواند کلمه کاربری و رمز عبورخود رادر اختیار فرد
                    دیگری قرار دهد که در غیر این صورت کلیه مسئولیت ها و تعهدات
                    مندرج در بند های این تعهدنامه به عهده کاربر میباشد <br />
                    کاربر قبول میکند کلیه موارد لازم در مورد بسته بندی صحیح و
                    عدل بندی را با هزینه خود انجام دهد تا بسته در زمان حمل پاره
                    نشود و چنانچه مرسوله به بسته بندی مجدد نیاز داشت هزینه آن را
                    طبق نظرکارشناس بپردازد یا مبلغ بسته بندی از حساب کیف پول
                    کاربر اتوماتیک کسر گردد <br />
                    خاطر نشان میگردد که سفارش هایی که تا قبل از ساعت 10 همان روز
                    در سامانه آواکس ثبت گردد ، جهت جمع آوری ارجاع و تا ساعت 18
                    از محل ثبت شده برای فرستنده جمع آوری میگردد و سفارشاتی که
                    بعد از ساعت 10 ثبت گردد حداکثر تا ساعت 12 روز بعد جمع آوری
                    میشود <br />
                    کاربر میپذیرد در صورت عدم جمع آوری مرسوله ثبت شده در سامانه
                    ظرف 24 ساعت تاخیر در جمع آوری را به اطلاع شرکت برسانم در غیر
                    این صورت حق هرگونه اعتراض نسبت به جمع آوری کالا را از خود
                    سلب نموده است <br />
                    جمع آوری بارها، از درب منزل یا محل کار انجام می شود و و
                    مرسوله بایستی باید ، در محل درب ورودی ساختمان تحویل داده شود
                    و در صورت نیاز به رویت محتویات مرسوله امکان بازدید آن فراهم
                    گردد.
                    <br />
                    همچنین چنانچه از درج امضا در بخش امضای مشتری در
                    فاکتوردریافتی از سامانه خودداری نماید حق هرگونه اعتراضی را
                    نسبت به دریافت غرامت ناشی از خسارت یا فقدان مرسوله را از خود
                    سلب می نماید. <br />
                    کاربرنمیتواند از بارکد نامعتبر استفاده نماید در صورتی که از
                    یک بارکد نامعتبر(کنسل شده) یا بارکدی که قبلا مرسوله آن ارسال
                    شده استفاده کند. شامل جریمه نقدی تا 5 برار هزینه بارکد
                    استفاده شده خواهد شد
                    <br />
                    مرسوله جمع آوری شده تحت هیچ شراطی عودت داده نخواهد شد مگر
                    اینکه مشکل قانونی داشته باشد
                    <br />
                    <br /> <br />
                    کنسلی سفارش
                    <br />
                    در صورت ثبت سفارش از طریق سامانه آواکس، چنانچه درخواست کنسلی
                    سفارش را داشته باشد هیچ مبلغی عودت داده نخواهد شد وچنانچه در
                    زمان تحویل مرسولات، بسته ای تحویل داده نشود، به منزله کنسل
                    شدن مرسوله می باشد چنانچه مرسوله از سامانه غیرپستی باشد، تا
                    قبل از جمع آوری قابل کنسل کردن بوده و چنانچه جمع در زمان ثبت
                    سفارش و استفاده از سرویس پسکرایه یا پرداخت در محل مبلغ
                    1،500،000 ريال داخل کیف پول بلوکه خواهد شد. درصورت درخواست
                    کنسل کردن سفارش پس کرایه، چنانچه تعداد سفارش های پس کرایه
                    ثبت شده زیر10 سفارش باشد مبلغ عودت و در صورت ثبت سفارش بالای
                    10 تا، مبلغ عودت نخواهد شد و از مبلغ بلوکه شده می توان به
                    جای هزینه سفارش پیش کرایه استفاده کرد و چنانچه مبلغ بلوکه
                    شده کفاف هزینه را ندهد کاربر میبایست هزینه فوق را پرداخت
                    نماید کاربر،چنانچه درخواست بازگشت کیف پول را داشته باشد این
                    امر با ارسال تیکت و درخواست بازگشت کیف پول امکان پذیر میباشد
                    ۷۲ ساعت پس از ارسال تیکت و اعلام شماره شبا مبلغ باقیمانده
                    کیف پول عودت داده خواهد شد
                    <br />
                    <br />
                    تعهدات بیمه ای
                    <br />
                    کلیه مرسولات تا درب محل گیرنده دارای بیمه می باشد و پس از
                    تحویل به گیرنده و دریافت امضای گیرنده، هیچ گونه غرامتی
                    پرداخت نخواهد شد لذا گیرنده بایستی از دریافت مرسوله آسیب
                    دیده خودداری نماید شرکت تنها در صورتی غرامت خسارت مرسوله را
                    پرداخت می نماید که خود، کالا را بسته بندی نموده باشد. همچنین
                    بیمه انتخاب شده متضامن کالاهایی که دارای بسته بندی استاندارد
                    نمی باشند، نخواهد بود. مشتریانی که بیش از ۲ بار در ۱۰۰
                    مرسوله درخواست خسارت نمایند هیچگونه خسارتی حتی با رعایت شروط
                    فوق پرداخت نخواهد شد در صورت دست دوم بودن کالا، قیمت کالای
                    نو مشابه پس از برآورد معادل 50% قیمت کالای نو تا سقف بیمه
                    درخواست شده پرداخت میشود در زمان درخواست غرامت برای مرسولات
                    ثبت شده با سرویس ، می بایستی مشخصات کارت ملی متقاضی غرامت
                    (تصویر کارت ملی)، آدرس و شماره حساب در بخش مشخصات متقاضی
                    غرامت در درسایت درج گردد
                    <br />
                    <br />
                    ممنوعات پستی
                    <br />
                    ممنوعات پستی به شرح ذیل میباشند: مایعات ، مرسولات شکستنی،
                    تجهیزات ماهواره، فیلترشکن ها، دارو ، مشروبات الکی و مواد
                    مخدر، تجهیزات نظامی، لوازم جنسی، مواد محترقه، اسکریپت های
                    غیرمجاز، لوازم قمار، تجهیزات مخابراتی غیرمجاز، تجهیزات
                    جاسوسی، اقلام مستهجن ، فالگیری و رمالی، پول نقد، چک، سفته ،
                    اوراق بهادار و جواهرات، فرش، مدارک شناسایی، اسناد و همچنین
                    در ارسال به سایر کشورها هم پس از دریافت مرسوله توسط فعال
                    پستی به شما اعلام خواهد شد که مرسوله جزء ممنوعات پستی به
                    کشور مقصد مورد نظرشما هست یا خیر زمان بندی جمع آوری سفارش
                    هایی که درخواست آنها تا قبل از ساعت 10صبح باشد همان روز و
                    زمان جمع آوری سفارشاتی که پس از ساعت10 صبح ثبت شوند، در
                    اولین روز کاری بعد از ثبت سفارش خواهد بود .
                    <br />
                    <br />
                    قوانین اجرایی
                    <br />
                    میپذیرم که وزن و محتوای بسته را بدرستی به دقت و صداقت اعلام
                    نماید.اگر چنانچه وزن اعلام شده مغایر با وزن واقعی باشد (که
                    این مورد در واحد تجزیه و مبادلات مشخص می گردد)، سفارش کنسل
                    خواهد شد و مسئولیت تاخیر در ارسال، هزینه سفارش مجدد و یا
                    هرگونه خسارت ناشی از این امر به عهده اینجانب خواهد بود.
                    میپذیرم که آدرس گیرنده را در سیستم به درستی اعلام نماید تا
                    موجب برگشتی سفارش و یا هزینه های نگهداری در باجه معطله
                    نگردد. میپذیرم هماهنگی لازم را با گیرنده برای اخذ مرسوله ای
                    که در باجه معطله می باشد بنماید. میپذیرم آدرس فرستنده اعم از
                    استان، شهر و منطقه را صحیح انتخاب نماید و چنانچه این امر به
                    درستی صورت نگیرد مسئولیت ناشی از تاخیر در جمع آوری و یا
                    کنسلی سفارش به عهده اینجانب خواهد بود. میپذیرم هر گونه شکایت
                    در خصوص خسارت وارده به هر مرسوله ای را صرفا ظرف 24ساعت پس از
                    سفارش از و عدم پذیرش آن مرسوله اعلام دارم و در غیر این صورت
                    هیچ گونه اعتراضی نخواهد داشت ضمنا تعهد بیمه مرسوله تا لحظه
                    تحویل آن به گیرنده اعتبار خواهد داشت. میپذیرم که کالای فاسد
                    شدنی ، ممنوعات پستی و قاچاق، وزن بیش از 30کیلو، مایعات و
                    ابعاد بیش از 1 متر در مرسوله پستی قرار ندهد و مندرجات بند
                    ممنوعات پستی رارعایت نماید . میپذیرم که کالای شکستنی ارسال
                    ننماید مگر آنکه کلیه ضوابط بسته بندی را رعایت نموده باشد، که
                    در صورت عدم رعایت ضابطه فوق و بروز خسارت، هیچ اعتراضی نخواهد
                    داشت و مسئولیت محتوای کلیه کالاهای مندرج در بسته به عهده
                    اینجانب می باشد، همچنین شرکت هیچ گونه مسئولیتی در قبال اطلاع
                    رسانی بسته بندی مرسوله ندارد و در صورت ارسال مرسوله با هرنوع
                    بسته بندی تبعات آن به عهده فرستنده می باشد. کاربر میپزیرد
                    سفارش خود را که حاوی کد رهگیری می باشد را پرینت و بر روی
                    بسته الصاق نماید وحتما آنرا امضا کند و سپس نسخه دیگر را به
                    امضای جمع آور برساند و به عنوان رسید نزد خود نگهدارد.. ضمنا
                    کلیه قوانین پستی را در خصوص محتوای بسته پستی رعایت نماید و
                    اگر خلاف این امر را انجام دهد کلیه مسئولیت های ناشی از خسارت
                    و غیره به عهده وی می باشد و اگر چنانچه به پرینتر دسترسی
                    نداشته باشد، آدرس فرستنده، گیرنده و شماره سفارش را بر روی
                    بسته بندی مرسوله با ماژیک درج بنماید. کاربر میپزیرد ازکلمه
                    کاربری و رمز عبورم فرد دیگری استفاده نخواهد کرد که در غیر
                    این صورت کلیه مسئولیت ها و تعهدات مندرج در بند های این
                    تعهدنامه به عهده اینجانب خواهد بود. میپذیرم کلیه موارد لازم
                    در مورد بسته بندی صحیح و عدل بندی را با هزینه خودم انجام دهم
                    تا بسته در زمان حمل پاره نشود و چنانچه مرسوله ام به بسته
                    بندی مجدد نیاز داشت هزینه آن را طبق نظرکارشناس بپردازم یا
                    مبلغ بسته بندی از حساب کیف پول اینجانب اتوماتیک کسر گردد.
                    <br />
                    متعهد و مطلع هستم که جمع آوری بارها، از درب منزل یا محل کار
                    انجام می شود و روند دریافت آن به گونه ای است که بار باید به
                    جمع آور محترم، در محل درب ورودی ساختمان تحویل داده شود و در
                    صورت نیاز به رویت محتویات مرسوله امکان بازدید آن فراهم گردد.
                    تعهد مینماید چنانچه از درج امضا در بخش امضای مشتری در فاکتور
                    خودداری نماید (که بصورت اتوماتیک پس از ثبت سفارش دانلود و در
                    اختیارم قرار گرفت) حق هرگونه اعتراضی را نسبت به دریافت غرامت
                    ناشی از خسارت یا فقدان مرسوله را از خود سلب می نماید. این
                    موارد یکبار دیگر در زمان پرداخت مبلغ هزینه ارسال بصورت
                    الکترونیک به تایید اینجانب رسیده است (در زمان پرداخت، تایید
                    نمودم که قوانین را خواندم و قبول دارم). . میپذیرم اگر شرکت
                    پستی به هر علتی از حمل بسته اینجانب خودداری کرد حق هر گونه
                    اعتراضی را از خود سلب می نماید و اجازه شکایت در این خصوص را
                    نخواهد داشت. جهت اطلاع از روند پرداخت حق مقر نیز به بخش
                    دستورالعمل مندرج در سایت مراجعه نمایید . در صورتی که از یک
                    بارکد نامعتبر(کنسل شده) یا بارکدی که قبلا مرسوله آن رهسپاری
                    شده استفاده کنید. شامل جریمه نقدی تا 5 برار هزینه بارکد
                    استفاده شده خواهید شد.
                    <br /> <br />
                    قوانین مالی
                    <br />
                    <br />
                    کنسلی سفارش
                    <br />
                    می پذیرم در صورت ثبت سفارش از طریق آواکس، چنانچه درخواست
                    کنسلی سفارش را داشته باشد هیچ مبلغی عودت داده نخواهد شد می
                    پذیرم چنانچه در زمان تحویل مرسولات، بسته ای تحویل داده نشود،
                    به منزله کنسل شدن مرسوله می باشد. میپذیرم چنانچه مرسوله از
                    سامانه غیرپستی باشد، تا قبل از جمع آوری قابل کنسل کردن بوده
                    و چنانچه برای جمع آوری مراجعه شود یا اینکه جمع آوری انجام
                    شود برای کنسلی هیچ وجهی مسترد نخواهد شد. مشتری گرامی چنانچه
                    درخواست بازگشت کیف پول را داشته باشید این امر با ارسال تیکت
                    و درخواست بازگشت کیف پول امکان پذیر میباشد ۷۲ ساعت پس از
                    ارسال تیکت و اعلام شماره شبا مبلغ باقیمانده کیف پول شما عودت
                    داده خواهد شد.
                    <br />
                    <br />
                    تعهدات بیمه ای
                    <br />
                    کلیه مرسولات تا درب محل گیرنده دارای بیمه می باشد و پس از
                    تحویل به گیرنده و دریافت امضای گیرنده، هیچ گونه غرامتی
                    پرداخت نخواهد شد لذا گیرنده بایستی از دریافت مرسوله آسیب
                    دیده خودداری نماید. شرکت تنها در صورتی غرامت خسارت مرسوله را
                    پرداخت می نماید که خود، کالا را بسته بندی نموده باشد. همچنین
                    بیمه انتخاب شده متضامن کالاهایی که دارای بسته بندی استاندارد
                    نمی باشند، نخواهد بود. مشتریانی که بیش از ۲ بار در ۱۰۰
                    مرسوله درخواست خسارت نمایند هیچگونه خسارتی حتی با رعایت شروط
                    فوق پرداخت نخواهد شد. در صورت دست دوم بودن کالا، قیمت کالای
                    نو مشابه پس از برآورد معادل 50% قیمت کالای نو تا سقف بیمه
                    درخواست شده پرداخت میشود. در زمان درخواست غرامت برای مرسولات
                    ثبت شده با سرویس آواکس ، می بایستی مشخصات کارت ملی متقاضی
                    غرامت (تصویر کارت ملی)، آدرس و شماره حساب در بخش مشخصات
                    متقاضی غرامت در لینک eop.post.ir درج گردد.
                    <br />
                    <br />
                    ممنوعات پستی
                    <br />
                    ممنوعات پستی به شرح ذیل میباشند: مایعات ، مرسولات شکستنی،
                    تجهیزات ماهواره، فیلترشکن ها، دارو ، مشروبات الکی و مواد
                    مخدر، تجهیزات نظامی، لوازم جنسی، مواد محترقه، اسکریپت های
                    غیرمجاز، لوازم قمار، تجهیزات مخابراتی غیرمجاز، تجهیزات
                    جاسوسی، اقلام مستهجن ، فالگیری و رمالی، پول نقد، چک، سفته ،
                    اوراق بهادار و جواهرات، فرش، مدارک شناسایی، اسناد و همچنین
                    در ارسال به سایر کشورها هم پس از دریافت مرسوله توسط فعال
                    پستی به شما اعلام خواهد شد که مرسوله جزء ممنوعات پستی به
                    کشور مقصد مورد نظرشما هست یا خیر
                  </p>

                  <Modal.Footer className="d-flex align-item-center justify-content-center">
                    <button
                      className="btn-success-style w-50"
                      type="button"
                      onClick={() => {
                        setModalRules(false);
                        setModalSubmitFirst(true);
                      }}
                    >
                      قوانین را خواندم و پذیرفتم
                    </button>
                  </Modal.Footer>
                </div>
              </Modal.Body>
            </Modal>

            <Modal show={modalSubmitFirst} direction="rtl">
              <Modal.Header className="d-flex align-item-center justify-content-center">
                <Modal.Title>لطفا موارد زیر را مشخص نمایید</Modal.Title>
              </Modal.Header>
              <Modal.Body
                className="d-flex align-item-center justify-content-center text-right "
                style={{ textAlign: "right", direction: "rtl" }}
              >
                <div className="w-100">
                  <Row className="">
                    {isAgent === false && (
                      <Fragment>
                        <FormGroup>
                          <Form.Check
                            type="checkbox"
                            name="printable"
                            className="d-inline-block mx-2"
                            onChange={e => {
                              setPackagingNeeded(e.target.checked);
                            }}
                          />
                          <Form.Label className=" fw-bold">
                            نیاز به بسته بندی بسته پستی خود توسط جمع آور آواکس
                            دارم.
                          </Form.Label>
                          <p>
                            با انتخاب این گزینه بسته بندی و پرینت فاکتور مرسوله
                            شما توسط نماینده در محل دفتر نمایندگی انجام میپذیرد.
                            <br />
                            در این صورت آدرس دقیق فرستنده و گیرنده را بصورت کامل
                            و خوانا بر روی بسته پستی خود درج نمایید
                          </p>
                          <hr
                            style={{
                              borderTop: "1px dashed",
                              width: "80%",
                              margin: "auto",
                            }}
                            className="my-2"
                          />
                        </FormGroup>

                        <FormGroup
                          style={
                            packagingNeeded ? { display: "none" } : undefined
                          }
                        >
                          <div className="d-inline-block mx-2 text-end fw-bold">
                            نیاز به پرینت فاکتور توسط نمایده سامانه آواکس :
                          </div>
                          <Form.Check
                            type="radio"
                            name="printable"
                            className="d-inline-block mx-2"
                            value={true}
                            onClick={e => setPrintNeeded(e.target.value)}
                          />
                          <Form.Label> دارم</Form.Label>

                          <Form.Check
                            type="radio"
                            name="printable"
                            className="d-inline-block mx-2"
                            value={false}
                            onClick={e => setPrintNeeded(e.target.value)}
                          />
                          <Form.Label> ندارم</Form.Label>
                          <div>
                            <ul>
                              <li>
                                چنانچه امکان پرینت فاکتور را ندارید، آدرس دقیق
                                فرستنده و گیرنده را بصورت واضح و خوانا بر روی
                                بسته پستی خود درج نمایید.
                              </li>
                              <li>
                                چنانچه امکان پرینت فاکتور را دارید، از فاکتور
                                خود در دو نسخه پرینت تهیه کرده ، یک فاکتور را بر
                                روی بسته خود بچسبانید بصورتی که تا تحویل مرسوله
                                از آن جدا نشود و در فاکتور دوم از جمع آور امضا
                                گرفته و نزد خود نگه دارید.
                              </li>
                            </ul>
                          </div>
                          <hr
                            style={{
                              borderTop: "1px dashed",
                              width: "80%",
                              margin: "auto",
                            }}
                            className="my-2"
                          />
                        </FormGroup>
                      </Fragment>
                    )}

                    <FormGroup className="my-3">
                      <Form.Label className="mb-0">
                        <h6>نوع تحویل:</h6>
                      </Form.Label>
                      <Form.Select
                        defaultValue={1}
                        onChange={e =>
                          setDeliveryType(parseInt(e.target.value))
                        }
                      >
                        <option value={1}>فرودگاهی</option>
                        <option value={2}>درب تا درب</option>
                      </Form.Select>
                    </FormGroup>

                    <FormGroup>
                      <Form.Check
                        type="checkbox"
                        name="smsable"
                        className="d-inline-block mx-2"
                        onChange={e => setSmsNeeded(e.target.checked)}
                      />
                      <Form.Label className=" fw-bold">
                        درخواست دریافت پیامک در مراحل ارسال را دارم.
                      </Form.Label>
                    </FormGroup>
                  </Row>
                  <Modal.Footer className="d-flex align-item-center justify-content-center">
                    <div className="mx-2 px-2 d-flex align-items-center justify-content-center">
                      <Button
                        className="btn-success-style mx-1"
                        onClick={() => {
                          setModalSubmitFirst(false);
                          setShowDocumentUploadModal(true);
                        }}
                      >
                        بعدی
                      </Button>

                      <Button
                        className="btn-cancel-style mx-1"
                        onClick={() => {
                          setModalSubmitFirst(false);
                        }}
                      >
                        انصراف
                      </Button>
                    </div>
                  </Modal.Footer>
                </div>
              </Modal.Body>
            </Modal>

            <Modal show={showModalWarning} direction="rtl">
              <Modal.Header className="d-flex align-item-center justify-content-center">
                <Modal.Title>توجه</Modal.Title>
              </Modal.Header>
              <Modal.Body
                className="d-flex align-item-center justify-content-center text-right "
                style={{ textAlign: "right", direction: "rtl" }}
              >
                <Form className="w-100">
                  <Row>
                    <p style={{ fontSize: "17px" }}>
                      شما در حال ثبت سفارش برای دیگران هستید، کلیه مسئولیت های
                      ارسال بار غیرمجاز و خلاف مقررات بعهده دارنده پنل کاربری می
                      باشد.
                    </p>
                  </Row>
                  <Modal.Footer className="d-flex align-item-center justify-content-center">
                    <Button
                      className="btn-success-style"
                      onClick={() => setShowModalWarning(false)}
                    >
                      قبول
                    </Button>
                  </Modal.Footer>
                </Form>
              </Modal.Body>
            </Modal>

            <Modal show={modalListService} direction="rtl" className="modal-lg">
              <Modal.Header className="d-flex align-item-center justify-content-center">
                <Modal.Title>لیست سرویس های پستی برای این مرسوله</Modal.Title>
              </Modal.Header>
              <Modal.Body
                className="d-flex align-item-center justify-content-center text-right "
                style={{ textAlign: "right", direction: "rtl" }}
              >
                <div className="w-100">
                  <Table striped className="mb-5">
                    <thead>
                      <tr>
                        <th></th>
                        <th className="text-secondary">سرویس دهنده</th>
                        <th className="text-secondary">نام سرویس دهنده</th>
                        <th className="text-secondary">نوع سرویس</th>
                        <th className="text-secondary">مدت زمان ارسال</th>
                        <th className="text-secondary">هزینه پستی</th>
                        <th className="text-secondary">قیمت نهایی</th>
                      </tr>
                    </thead>
                    <tbody>
                      {finalServiceList.map((item, idx) => (
                        <tr className="align-middle" key={idx}>
                          <td>
                            <Form.Check
                              type="radio"
                              name="selectedService"
                              value={item}
                              className="d-inline-block mx-1"
                              onClick={() => {
                                setSelectedService(item);
                              }}
                            />
                          </td>
                          <td>
                            <img
                              src={item.data.image}
                              height={60}
                              width={60}
                              className="d-inline-block"
                            />
                          </td>
                          <td className="h5 ">{item.data.name}</td>
                          <td className="h5">{item.data.method_name}</td>
                          <td className="h5">بین 48 تا 72 ساعت</td>
                          <td className="h5">
                            {item.data.quote
                              ? item.data.quote.toLocaleString() + "ريال"
                              : item.data.description}
                          </td>
                          <td className="h5">
                            {item.data?.totalPrice?.toLocaleString()} ریال
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>

                  <Modal.Footer className="d-flex align-item-center justify-content-center">
                    <Row className="mx-5 px-5">
                      <Col>
                        <Button
                          className="btn-success-style"
                          onClick={() => {
                            chooseServiceType();
                          }}
                        >
                          تائید
                        </Button>
                      </Col>
                      <Col>
                        <Button
                          className="btn-cancel-style"
                          onClick={() => setModalListService(false)}
                        >
                          انصراف
                        </Button>
                      </Col>
                    </Row>
                  </Modal.Footer>
                </div>
              </Modal.Body>
            </Modal>
          </Container>
        </div>

        {newAddress === true && (
          <NewExternalAddress
            close={() => setNewAddress(false)}
            set={item => setRAddress(item)}
          />
        )}

        {showPreviousAdressModal === true && (
          <PreviousAdress
            close={() => setShowPreviousAdressModal(false)}
            set={item => {
              setRAddress(item);
              setShowPreviousAdressModal(false);
            }}
          />
        )}

        {senderOrGetterRegAdd !== -1 && (
          <NewAddress
            senderOrgetter={senderOrGetterRegAdd}
            onClose={number => {
              setModalAddressSender(false);
              setSenderOrGetterRegAdd(() => number);
            }}
            setResult={item => {
              if (senderOrGetterRegAdd == 0) {
                selectAddS(item);
              }
              setSenderOrGetterRegAdd(() => -1);
            }}
          />
        )}

        {showDocumentUploadModal && (
          <DocumentUploadModal
            set={files => {
              setShowDocumentUploadModal(false);
              setShowModalInfo(true);
              setFiles(files);
            }}
            close={() => {
              setShowDocumentUploadModal(false);
              setFiles([]);
            }}
          />
        )}

        <ExInfoModal
          show={showModalInfo}
          onSubmit={sendRequest}
          onClose={() => {
            setShowModalInfo(false);
            setFiles();
          }}
        />

        <FooterPostup />
      </>
    );
  }
}

export default NewExternalAgent;
